import { Box, useMediaQuery, useTheme } from "@mui/material";
import { ListItemBase } from "./styled-components";

/**
 * This component is part of the VR app V2 redesign.
 * It applies different styles for mobile and VR.
 */

interface IBybListSubheader {
  children: React.ReactNode;
}

const BybListSubheader = ({ children }: IBybListSubheader) => {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  const subheader = (
    <Box
      sx={{
        padding: isSmDown ? theme.spacing(2) : theme.spacing(2, 4),
        backgroundColor: isSmDown ? "dsBase.v100" : "dsSurface.v200",
        color: "dsNeutral.v400",
      }}
    >
      {children}
    </Box>
  );

  return (
    <ListItemBase sticky sx={isSmDown ? undefined : { cornerShape: "squircle", borderRadius: "24px", overflow: "hidden" }}>
      {subheader}
    </ListItemBase>
  );
};

export default BybListSubheader;
